const API_BASE = process.env.REACT_APP_API_URL || '';

export const API_ENDPOINTS = {
  billing: {
    uploads:         () =>                  `${API_BASE}/api/billing/uploads`,
    uploadClaims:    (uploadId: string) =>  `${API_BASE}/api/billing/uploads/${uploadId}/claims`,
    claim:           (claimId: string) =>   `${API_BASE}/api/billing/claims/${claimId}`,
    jobs:            () =>                  `${API_BASE}/api/billing/jobs`,
    auditEvents:     () =>                  `${API_BASE}/api/billing/audit-events`,
    myPractices:     () =>                  `${API_BASE}/api/billing/me/practices`,
    practiceClaims:  (practiceId: string) => `${API_BASE}/api/billing/practices/${practiceId}/claims`,
    providerCrosswalk: (practiceId: string) => `${API_BASE}/api/billing/practices/${practiceId}/provider-crosswalk`,
    practiceProviders: (practiceId: string) => `${API_BASE}/api/billing/practices/${practiceId}/providers`,
    claimAudit:      (claimId: string) =>    `${API_BASE}/api/billing/claims/${encodeURIComponent(claimId)}/audit`,
    jobScreenshot:   (jobId: string) =>      `${API_BASE}/api/billing/jobs/${encodeURIComponent(jobId)}/screenshot`,
    eobs:            () =>                   `${API_BASE}/api/billing/eobs`,
    eobViewUrl:      (imageId: string) =>    `${API_BASE}/api/billing/eobs/${encodeURIComponent(imageId)}/view-url`,
    markCompleted:   (claimId: string) =>    `${API_BASE}/api/billing/claims/${claimId}/mark-completed`,
    unmarkCompleted: (claimId: string) =>    `${API_BASE}/api/billing/claims/${claimId}/unmark-completed`,
    // Biller management (ADMIN / CREDENTIALING_ADMIN)
    billers:         () =>                  `${API_BASE}/api/billing/billers`,
    biller:          (id: string) =>        `${API_BASE}/api/billing/billers/${id}`,
    billerPractices: (id: string) =>        `${API_BASE}/api/billing/billers/${id}/practices`,
    billerPractice:  (id: string, practiceId: string) =>
                                            `${API_BASE}/api/billing/billers/${id}/practices/${practiceId}`,
    // Practice/provider/payer management (old practices/providers tables)
    practices:       () =>                  `${API_BASE}/api/billing/practices`,
    practice:        (id: string) =>        `${API_BASE}/api/billing/practices/${id}`,
    providers:       () =>                  `${API_BASE}/api/billing/providers`,
    payers:          () =>                  `${API_BASE}/api/billing/payers`,
    // Practice-side biller assignment (mirror of billerPractices, from the practice)
    practiceBillers: (practiceId: string) => `${API_BASE}/api/billing/practices/${practiceId}/billers`,
    practiceBiller:  (practiceId: string, userId: string) =>
                                            `${API_BASE}/api/billing/practices/${practiceId}/billers/${userId}`,
  },
  me: {
    allowedSources: () => `${API_BASE}/api/me/allowed-sources`,
  },
} as const;
